define('home/models/ForumProfile',[
    'underscore',
    'backbone',

    'core/UniqueModel',

    'home/collections/MostLikedUserCollection',
    'home/models/Feed',
    'home/models/FollowRecommendationFeed',
    'home/models/Forum',
    'home/models/ForumFeed',
], function (
    _,
    Backbone,

    UniqueModel,

    MostLikedUserCollection,
    Feed,
    FollowRecommendationFeed,
    Forum,
    ForumFeed
) {
    'use strict';

    var ForumProfile = Backbone.Model.extend({
        initialize: function (_attributes, options) {
            this.initializeRelated(
                'forum',
                _.defaults({
                    forum: { id: this.id },
                }, options),
                Forum
            );

            this.recent = new UniqueModel(ForumFeed, {
                id: this.id,
            });

            var fetchOptions = {
                forum: this.id,
            };

            this.mostLikedUsers = new Feed({
                fetchOptions: fetchOptions,
            }, {
                collectionClass: MostLikedUserCollection,
            });

            this.interestingForums = FollowRecommendationFeed.createForumFollowRecommendationFeed();
            this.interestingUsers = FollowRecommendationFeed.createUserFollowRecommendationFeed();
        },

        ensureFetched: function () {
            this.interestingForums.ensureFetched();
            this.interestingUsers.ensureFetched();
        },

        toJSON: function () {
            return _.defaults({
                forum: this.forum.toJSON(),
                recent: this.recent.toJSON(),
                mostLikedUsers: this.mostLikedUsers.toJSON(),
            }, Backbone.Model.prototype.toJSON.call(this));
        },
    });

    UniqueModel.addType('ForumProfile', ForumProfile);

    return ForumProfile;
});

